import { Directive, HostListener, Input, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { table } from 'console';

@Directive({
  standalone: false,
  selector: '[tableCopy]',
})
export class TableCopyingDirective implements AfterViewInit {
  @Input() dropdowns?: { title: string; label: string }[];
  @Input() tables: any[]; //this is supposed to be an array of nativeelements or elementref or undef
  constructor(private changeDetector: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    //this helps with modals. for visibility toggles, use display:none instead of ngif
    this.changeDetector.detectChanges();
  }

  @HostListener('copy', ['$event'])
  onCopyTable(evt: ClipboardEvent): void {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount <= 0 || selection.isCollapsed) {
      //No selection, ignore
      return;
    }
    const range = selection.getRangeAt(0);
    let tableSelected = false;
    let moreThanTableSelected = []; //all have to be true
    for (let cont of this.tables) {
      const container = cont?.nativeElement || cont; //sometimes it already is a nativeElement
      if (container && container.offsetParent !== null) {
        //container exists, and container is not hidden
        if (!(!container?.contains(selection.anchorNode) && !container?.contains(selection.focusNode) && !selection.containsNode(container))) {
          //this container has been highlighted
          tableSelected = true;
        }
        if (!container.contains(range.commonAncestorContainer)) {
          //it has selected more than just the table
          moreThanTableSelected.push(true);
        } else {
          moreThanTableSelected.push(false);
        }
      }
    }
    if (!tableSelected) {
      //The user has not highlighted either tables, ignore
      return;
    }

    //This is assuming that the user will select the full row. if the first n amount of cells are not selected, the
    //tab spacing doesn't copy over
    const extraction = range.cloneContents();
    if (moreThanTableSelected.reduce((a, b) => a && b)) {
      //selection contains more than the table (in case user wants to select headers or something)
      let fullHtml = '';
      let fullPlain = '';
      extraction.childNodes.forEach((node: Node) => {
        if (node instanceof HTMLElement) {
          if (node.classList.value.includes('tablecontainer')) {
            //this is the table
            const arr = this.constructTable(node);
            fullHtml += arr[0];
            fullPlain += arr[1];
          } else {
            fullHtml += node.innerHTML;
            fullPlain += node.innerText;
          }
        }
      });
      evt.clipboardData?.setData('text/html', fullHtml);
      evt.clipboardData?.setData('text/plain', fullPlain);
    } else {
      const arr = this.constructTable(extraction);
      evt.clipboardData?.setData('text/html', arr[0]);
      evt.clipboardData?.setData('text/plain', arr[1]);
    }
    evt.preventDefault();
  }

  constructTable(node): any {
    let table = '<table>';
    const rows = node.querySelectorAll('.tablerow');
    //in some scenarios, it wont copy any tablerow
    table += '<tr>';
    if (rows.length <= 0) {
      const cells = node.querySelectorAll('.tablecolumn');
      if (cells.length <= 0) {
        //if the copy function has made it this far, this is still part of the table. it is a #document-fragment
        table += `<td style="mso-number-format:'\\@';">${node.textContent}</td></tr></table>`;
        return [table, node.textContent];
      }
      cells.forEach((cell: HTMLElement) => {
        table += `<td style="mso-number-format:'\\@';">${this.getCellInnerText(cell)}</td>`;
      });
      table += '</tr>';
    }
    rows.forEach((row: HTMLElement) => {
      table += '<tr>';
      const cells = row.querySelectorAll('.tablecolumn');
      cells.forEach((cell: HTMLElement) => {
        //gemini reccomends this style to retain large numbers when copying
        table += `<td style="mso-number-format:'\\@';">${this.getCellInnerText(cell)}</td>`;
      });
      table += '</tr>';
    });
    table += '</table>';
    const plaintext = Array.from(rows)
      .map((row: HTMLElement) =>
        Array.from(row.querySelectorAll('.tablecolumn'))
          .map((c: HTMLElement) => this.getCellInnerText(c))
          .join('\t'),
      )
      .join('\n');
    return [table, plaintext];
  }

  getCellInnerText(cell) {
    if (this.dropdowns && cell?.title) {
      for (let drop of this.dropdowns) {
        if (cell.title === drop.title) {
          return `${drop.title}: ${drop.label}`;
        }
      }
    }
    return cell.innerText.trim();
  }
}
